<template>
  <section class="news-container">
    <div class="content-container">
      <div class="filter-container">
        <div class="filter-list">
          <v-date-picker
            v-model="date"
            :format="'dd-MM-yyyy HH:mm:ss'"
            :valueFormat="'yyyy-MM-dd HH:mm:ss'"
            :default-time="['00:00:00', '23:59:59']"
            type="datetimerange"
            @change="filterData"/>
          <v-input
            v-model="phone"
            type="number"
            placeholder="Phone No., Name"
            @keyEnter="filterData"
            @blur="filterData"></v-input>
        <!--        <v-select  @change="filterData"></v-select>-->
        </div>
      </div>

      <div class="transparent">
        <el-table
          :data="smsList"
          style="width: 100%"
          :header-row-class-name="headerClass"
        >
          <el-table-column
            width="120"
            label="Time">
            <template slot-scope="scope">
              <p>
                {{handlerTime(scope.row.created_at)[0]}}
              </p>
              <p>
                {{handlerTime(scope.row.created_at)[1]}}
              </p>
            </template>
          </el-table-column>
          <el-table-column
            width="150"
            label="Destination" >
            <template slot-scope="scope">
              <div class="flex-algin">
                <!--                <p>{{scope.row.status===1?'Active':'Inactive'}}</p>-->
                <p class="font-weight">{{scope.row.to}}</p>
                <p ></p>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            width="150"
            label="Status" >
            <template slot-scope="scope">
              <div class="flex-algin">
                <!--                <p>{{scope.row.status===1?'Active':'Inactive'}}</p>-->
                <p :class="scope.row.status==0?'fail':''">{{hanlderStatus(scope.row.status)}}</p>
                <p></p>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            label="Content"
            prop="content"
          >
            <template slot-scope="scope">
              <div class="flex-algin">
                <p class="content-break">{{scope.row.content}}</p>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <v-pagination
      :total="pageConfig.total"
      :current="pageConfig.currentPage"
      @currentChange="currentChange"
    />

  </section>
</template>
<script>

import MixinOptions from '@/mixins/options'
import {getSmsLogList} from '@/api/admin-cms'

export default {
  name: 'smsLog',
  mixins: [MixinOptions],
  props:{
    headerClass:{
      type:Function,
      default:()=>{
        return 'headerClass'
      }
    }
  },
  data() {
    return {
      pageConfig: {
        //  分頁配置
        size:20,
        currentPage: 1,
        total: 10
      },
      smsList: [],
      date:'',
      phone:''
    }
  },
  computed: {

  },
  watch: {
    property: {
      immediate: true,
      handler() {
        this.network().getSmsLogList()
        // this.network().getNewsCategoriesList()
      }
    },
  },
  methods: {
    handlerTitle(title){
      return title['en-US']
    },
    hanlderStatus(status){
      let data = {
        0:'Fail',
        1:'Success',
        2:'Pretend'
      }
      return data[status]
    },
    handlerTime(time){
      return time = time?time.split(' '):['-','-']
    },
    filterData() {
      this.pageConfig.currentPage = 1
      this.network().getSmsLogList()
    },
    handleTab(){
      this.pageConfig.currentPage = 1
      this.network().getSmsLogList()
    },
    currentChange(page) {
      this.pageConfig.currentPage = page
      this.network().getSmsLogList()
    },
    network() {
      return {
        getSmsLogList: async (params = {}) => {
          const { data } = await getSmsLogList({
            page: this.pageConfig.currentPage,
            size: this.pageConfig.size,
            start_time:this.date?this.date[0]:'',
            end_time:this.date?this.date[1]:'',
            phone:this.phone
          })
          this.smsList = data.data
          this.pageConfig.total = data.total
        },
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.news-container {
  .content-container {
    position: relative;
    .el-table {
      margin-top: 15px;
      border:1px solid #E1E4E8;
      border-radius: 4px;
      ::v-deep .headerClass{
        background:#F6F8FA;
        th{
          background:#F6F8FA;
          .cell{
            padding: 16px;
            font-size: 14px;
            color: #24292E;
          }
        }
      }
    }
    .btn-list {
      text-align: center;
      span {
        margin-right: 10px;
      }
    }
    .filter-container {
      display: flex;
      //justify-content: space-between;
      //align-items: center;
      .filter-list {
        display: flex;
        justify-content: space-between;
      .el-input{
        margin: 0 20px;
      }
      }
    }
  }
  .dialog-container {
    padding: 15px;
  }
  .ic-order {
    .svg-inline--fa {
      color: #91939A;
      font-size: 12px;
    }
  }
  .img-banner {
    width: 150px;
  }
  ::v-deep .flex-algin{
    display: flex;
    flex-direction: column;
    justify-content:space-between ;
    p{
      min-height: 24px;
    }
  }
  .el-table{
    p:first-child{
      color: #24292E;
      font-size: 14px;
      //font-weight: 500;
    }
    .font-weight{
      font-weight: 500;
    }
    .content-break{
      word-break: break-word;
    }
  }
  .fail{
    color: #CB2431;
  }
}
</style>
